(function () {
    'use strict';
    /*
     * Copyright (c) 2016 In Hand Health.
     * All rights reserved.
     */

    /**
     * This controller is responsible for the payment method entry form. It handles
     * the initialization of the payment form, and the returned promise.
     */
    angular
        .module('ihh-common-web')
        .controller('PaymentMethodEntryCtrl', PaymentMethodEntryCtrl);

    PaymentMethodEntryCtrl.$inject = ['$scope', '$q', 'PaymentMethodEntryService', 'RestResources'];

    function PaymentMethodEntryCtrl($scope, $q, PaymentMethodEntryService, RestResources) {
        var vm = this;

        function activate() {
            displayBusyIndicator();

            PaymentMethodEntryService.setupBraintree($scope.clinicId, $scope.onPaymentMethodReceivedCallback()).then(function () {
                $scope.cleanUp();
            }, function (err) {
                RestResources.reportRestError('We were unable to configure our payment provider.', err);
            }).finally(function () {
                hideBusyIndicator();
            });
        }
        activate();

        // uses a promise to display the busy indicator
        function displayBusyIndicator () {
            vm.pricingPlanPromise = $q.defer().promise; // false promise
        }

        // clears the promise so that the busy indicator will no longer be displayed
        function hideBusyIndicator () {
            vm.pricingPlanPromise = null;
        }
    }
})();


